
/* styles */
require("!!vue-loader/node_modules/vue-style-loader!css-loader?minimize!../../node_modules/.10.3.0@vue-loader/lib/style-rewriter?id=data-v-807bfef8&scoped=true!less-loader!../../node_modules/.10.3.0@vue-loader/lib/selector?type=styles&index=0!./list.vue")

var Component = require("!../../node_modules/.10.3.0@vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/.10.3.0@vue-loader/lib/selector?type=script&index=0!./list.vue"),
  /* template */
  require("!!../../node_modules/.10.3.0@vue-loader/lib/template-compiler?id=data-v-807bfef8!../../node_modules/.10.3.0@vue-loader/lib/selector?type=template&index=0!./list.vue"),
  /* scopeId */
  "data-v-807bfef8",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/list.vue
// module id = 92
// module chunks = 1